import { FormProvider, useForm } from 'react-hook-form';
import { Box, Button, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';

import Modal from 'src/components/customModal';
import modals from 'src/constants/modals';
import { styledMainTitle } from 'src/components/InviteModal/styles';
import { ActionButtons } from 'src/layouts/main/styles';
import { handleCloseModal } from 'src/utils/propertyHelpers';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import { RHFTextField } from 'src/components';
import { FoundCompany } from 'src/api/company/search-company';
import { useSelector } from 'react-redux';
import { selectModal } from 'src/redux/slices/modal';
import useLoading from 'src/hooks/useLoading';
import addCompany from 'src/api/company/add-company';
import { dispatch } from 'src/redux/store';
import { getCompaniesThunk } from 'src/redux/slices/tableSlice';
import { validationSchema } from './validation';

const Content = () => {
	const { enqueueSnackbar } = useSnackbar();
	const { payload } = useSelector(selectModal<FoundCompany>);
	const { isLoading, setIsLoading } = useLoading();
	const form = useForm<FoundCompany>({
		resolver: yupResolver(validationSchema),
		defaultValues: payload,
	});

	const handleSubmit = async (data: FoundCompany) => {
		try {
			handleCloseModal();

			await addCompany(data);

			dispatch(getCompaniesThunk());

			handleCloseModal();
		} catch (e) {
			if (e instanceof Error) enqueueSnackbar(e.message, { variant: 'error' });
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<FormProvider {...form}>
			<form
				onSubmit={(e) => {
					e.stopPropagation();
					form.handleSubmit(handleSubmit)(e);
				}}
			>
				<Typography sx={styledMainTitle} pt={0}>
					VERIFY NEW COMPANY
				</Typography>
				<Box display='flex' flexDirection='column' gap='15px'>
					<RHFTextField name='regNum' label='Enter a registration number' />
					<RHFTextField name='tradingName' label='Enter a name' />
					<RHFTextField name='legalName' label='Enter a legal name' disabled />
				</Box>
				<ActionButtons mt={'20px'}>
					<Button variant='outlined' size='large' fullWidth onClick={handleCloseModal}>
						Cancel
					</Button>
					<LoadingButton variant='contained' size='large' fullWidth type='submit' loading={isLoading}>
						Submit
					</LoadingButton>
				</ActionButtons>
			</form>
		</FormProvider>
	);
};

const VerifyNewCompanyModal = () => (
	<Modal name={modals.verifyNewCompany} cardSx={{ overflow: 'visible', maxWidth: '550px' }}>
		<Content />
	</Modal>
);

export default VerifyNewCompanyModal;
